import React, { ReactElement } from "react";

import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { getPageProps } from "@services/initial-calls";
import { useDomainContext } from "@hooks/useDomainContext";
import FleetTrackingQuotesWrapper from "@components/layouts/fleetTrackingQuotesWrapper";
import MainBanner from "@components/fleettrackingquotes/mainBanner";
import OffersList from "@components/shared/offersList";

const WhyUs = dynamic(() => import("@components/fleettrackingquotes/whyUs"));

export default function FleetTrackingQuotesHome(): ReactElement {
    const { domain } = useDomainContext();

    return (
        <FleetTrackingQuotesWrapper>
            <MainBanner />
            <section>
                <OffersList offers={domain?.defaultOffers} />
            </section>
            <WhyUs />
        </FleetTrackingQuotesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home");
};
